var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "border-0 flex-grow-1",
      attrs: { "body-class": "pb-0 pt-1" }
    },
    [
      _c(
        "span",
        { staticClass: "d-flex justify-content-center font-weight-bold" },
        [_vm._v(_vm._s(_vm.workshop.name))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row align-items-stretch" }, [
        _c("div", { staticClass: "d-flex flex-column w-100" }, [
          _c("div", { staticClass: "d-flex flex-row border-bottom" }, [
            _c("span", { staticClass: "d-flex" }, [
              _vm._v("Количество заказов: " + _vm._s(_vm.tasksCountValidated))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-row" }, [
            _c("span", { staticClass: "d-flex" }, [
              _vm._v(
                "Последнее время отдачи: " + _vm._s(_vm.lastOrderDoneTimeTime)
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.showSOS
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex ml-1 w-25 text-white justify-content-center align-items-center sos active rounded"
              },
              [_vm._v("SOS")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d07f7b0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d07f7b0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MotivateWorkshopCard.vue
// module id = null
// module chunks = 